<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Student Surveys"
        backLink="/dashboard/reports"
    >
        <v-col cols="12" class="pa-1">
            <Stats class="pb-3" :stats="stats" />
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        :subtitle="
                            allLocations
                                ? 'Surveys By Location'
                                : `${selectedLocation.name} Surveys`
                        "
                        :allLocations="allLocations"
                        locationOptions
                        :selectedLocation="selectedLocation"
                        filter
                        :dateRange="dateRange"
                        reportUrl="/dashboard/reports/student-surveys"
                        @search="search = $event"
                    />
                    <v-data-table
                        :loading="loading"
                        ref="table"
                        :headers="headers"
                        :items="surveys"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        :groupBy="allLocations ? 'location' : null"
                        @current-items="collapse()"
                        @click:row="[$log($event.id), getSurvey($event.id)]"
                        style="cursor: pointer"
                    >
                        <template
                            v-slot:[`group.header`]="{
                                group,
                                items,
                                isOpen,
                                toggle,
                            }"
                        >
                            <th colspan="7">
                                <v-row
                                    no-gutters
                                    class="flex justify-start align-center pa-2"
                                >
                                    <v-icon @click="toggle" class="mr-3"
                                        >{{ isOpen ? "remove" : "add" }}
                                    </v-icon>
                                    <v-col>
                                        <div
                                            class="soli-grey text-subtitle-2 font-weight-bold"
                                        >
                                            {{ group }}
                                        </div>
                                        <div class="soli-grey text-small">
                                            • {{ items.length }} Survey(s)
                                        </div>
                                    </v-col>
                                </v-row>
                            </th>
                        </template>
                        <template v-slot:[`item.info.name`]="{ item }">
                            <div class="d-flex align-center py-2 soli-grey">
                                <div>
                                    <Link
                                        v-if="item.info.user_id"
                                        :href="`/profile/${item.info.user_id}/account`"
                                    >
                                        <v-list-item-title>
                                            {{ item.info.name }}
                                        </v-list-item-title>
                                    </Link>
                                    <v-list-item-title v-else>
                                        {{ item.info.name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.info.email }}
                                        <Clipboard
                                            :text="item.info.email"
                                            label="Copy Email"
                                            x-small
                                        />
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.date`]="{ item }">
                            <div class="font-bold soli-grey">
                                {{ item.date }}
                            </div>
                        </template>
                    </v-data-table>

                    <!--<template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="ma-3">
                            <div class="ma-3">test</div>
                        </td></template
                    >-->
                </v-container>
            </v-card>
        </v-col>
        <SoliResponsiveDialog
            v-if="showSurveyDetails"
            @reset="showSurveyDetails = null"
            :title="showSurveyDetails.user.name"
            :subtitle="showSurveyDetails.user.email"
            size="700"
            ><template #body>
                <v-simple-table>
                    <thead>
                        <tr>
                            <th class="text-left">Question</th>
                            <th class="text-left">Response</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Recommend Us?</td>
                            <td>{{ showSurveyDetails.recommend_us }}</td>
                        </tr>
                        <tr v-if="showSurveyDetails.recommend_us_reason">
                            <td>Reason</td>
                            <td>{{ showSurveyDetails.recommend_us_reason }}</td>
                        </tr>
                        <tr>
                            <td>Recommend Teacher?</td>
                            <td>{{ showSurveyDetails.recommend_teacher }}</td>
                        </tr>
                        <tr v-if="showSurveyDetails.recommend_teacher_reason">
                            <td>Reason</td>
                            <td>
                                {{ showSurveyDetails.recommend_teacher_reason }}
                            </td>
                        </tr>
                        <tr>
                            <td>Hear about us?</td>
                            <td>{{ showSurveyDetails.hear_about_us }}</td>
                        </tr>
                        <tr v-if="showSurveyDetails.hear_about_us_detail">
                            <td>Hear about us details</td>
                            <td>
                                {{ showSurveyDetails.hear_about_us_detail }}
                            </td>
                        </tr>
                        <tr v-if="showSurveyDetails.hear_about_us_other">
                            <td>Hear about us other</td>
                            <td>
                                {{ showSurveyDetails.hear_about_us_other }}
                            </td>
                        </tr>
                        <tr>
                            <td>What's most important?</td>
                            <td>
                                {{
                                    showSurveyDetails.most_important
                                        .map((e) => e)
                                        .toString()
                                        .replace(/,/g, ", ")
                                }}
                            </td>
                        </tr>
                        <tr
                            v-if="
                                showSurveyDetails.most_important_specific_goal
                            "
                        >
                            <td>Specific goal</td>
                            <td>
                                {{
                                    showSurveyDetails.most_important_specific_goal
                                }}
                            </td>
                        </tr>
                        <tr v-if="showSurveyDetails.most_important_other">
                            <td>Most important other</td>
                            <td>
                                {{ showSurveyDetails.most_important_other }}
                            </td>
                        </tr>
                        <tr>
                            <td>Are we delivering?</td>
                            <td>
                                {{ showSurveyDetails.are_we_delivering }}
                            </td>
                        </tr>
                        <tr>
                            <td>What's least important?</td>
                            <td>
                                {{
                                    showSurveyDetails.least_important
                                        .map((e) => e)
                                        .toString()
                                        .replace(/,/g, ", ")
                                }}
                            </td>
                        </tr>
                        <tr
                            v-if="
                                showSurveyDetails.least_important_specific_goal
                            "
                        >
                            <td>Specific goal</td>
                            <td>
                                {{
                                    showSurveyDetails.least_important_specific_goal
                                }}
                            </td>
                        </tr>
                        <tr v-if="showSurveyDetails.least_important_other">
                            <td>Least important other</td>
                            <td>
                                {{ showSurveyDetails.least_important_other }}
                            </td>
                        </tr>
                        <tr>
                            <td>What can we do better?</td>
                            <td>
                                {{ showSurveyDetails.do_better }}
                            </td>
                        </tr>
                        <tr>
                            <td>Source</td>
                            <td>
                                {{ showSurveyDetails.source }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template></SoliResponsiveDialog
        >
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import DateRange from "../../Components/Reports/DateRange.vue";
import Stats from "../../Components/Reports/Stats.vue";
import Clipboard from "../../Components/Clipboard.vue";
import axios from "axios";

export default {
    props: {
        surveys: {
            type: Array,
            default: () => [],
        },
        meta: {
            type: Array,
            default: () => [],
        },
        selectedLocation: {
            type: Object,
            default: () => {},
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
        totalNPSValue: {
            type: String,
            default: null,
        },
        totalResponseRate: {
            type: String,
            default: null,
        },
        totalReferrals: {
            type: Number,
            default: null,
        },
    },
    components: {
        AppLayout,
        Link,
        ReportHeader,
        DateRange,
        Stats,
        Clipboard,
    },
    data() {
        return {
            search: "",
            showMessage: false,
            expanded: [],
            loading: false,
            headers: [
                {
                    text: "Customer",
                    align: "start",
                    sortable: true,
                    value: "info.name",
                },
                {
                    text: "Score",
                    align: "start",
                    sortable: true,
                    value: "score",
                },
                {
                    text: "Submitted",
                    align: "start",
                    sortable: true,
                    value: "date",
                },
            ],
            showSurveyDetails: null,
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: "Surveys",
                    data: this.surveys.length,
                    color: "accent",
                    icon: "poll",
                },
                {
                    title: "Our Score",
                    data: this.totalNPSValue,
                    color: "soli-status-green",
                    icon: "show_chart",
                },
                {
                    title: "Response Rate",
                    data: this.totalResponseRate,
                    color: "soli-status-group",
                    icon: "question_answer",
                },
                {
                    title: "Referrals",
                    data: this.totalReferrals,
                    color: "orange",
                    icon: "campaign",
                },
            ];
        },
    },
    methods: {
        getSurvey(id) {
            this.loading = true;
            axios.get(route("surveys.show", id)).then((resp) => {
                this.loading = false;
                this.showSurveyDetails = resp.data;
            });
        },
        collapse() {
            if (!this.allLocations) return;
            this.$nextTick(() => {
                let obj = this.$refs.table.openCache;
                Object.keys(obj).forEach((e) => (obj[e] = false));
            });
        },
    },
};
</script>
